module.exports = __webpack_public_path__ + "static/media/door0103.496bbaea.jpg";